import { IUser } from '@/features/auth/model/types';
import LanguageSwitcher from '@/features/language-switcher/ui/language-switcher';
import { Flex } from '@chakra-ui/react';
import { profileActions } from '../model/constants';
import OptionItem from './option-item';

type Props = {
  user: IUser | null;
};

const ProfileOptions: React.FC<Props> = ({ user }) => {
  return (
    <Flex
      bg="white"
      shadow="xs"
      flex="1"
      roundedTop="2xl"
      direction="column"
      gap="1"
      py="4"
    >
      {profileActions
        .filter(
          (option) =>
            !option.authRequired || (option.authRequired && Boolean(user))
        )
        .map((option) => (
          <OptionItem key={option.title} option={option} />
        ))}

      <LanguageSwitcher />
    </Flex>
  );
};

export default ProfileOptions;
